Vue.component('battleAdmin', {
  template: templates.battleAdmin,
  data() {
    return {
      model: {
        battle: {
          user1Cards: null,
          user2Cards: null,
        },
        searchResults: []
      }
    }
  },
  methods: {
    searchUsers(user) {
      const c = this;
      let names = [];
      const twitchDisplayName = $(`[name="${user}"]`).val();
      
      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data.concat(c.model.searchResults);
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $(`[name="${user}"]`).autocomplete({
            source: names
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getUserId(twitchDisplayName) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          return user.twitchId;
        }
      }
    },
    save() {
      const c = this;
      const twitchDisplayName1 = $('[name="battle-user1"]').val();
      const twitchDisplayName2 = $('[name="battle-user2"]').val();

      const data = {
        user1TwitchId: c.getUserId(twitchDisplayName1),
        user2TwitchId: c.getUserId(twitchDisplayName2),
        user1Cards: c.model.battle.user1Cards,
        user2Cards: c.model.battle.user2Cards
      }

      battleService.test(data)
        .then(function (response) {
          c.reset();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    reset() {
      const c = this;
      $('[name="battle-user1"]').val('');
      $('[name="battle-user2"]').val('');
      c.model.battle = {
        twitchDisplayName1: null,
        user1Cards: null,
        twitchDisplayName2: null,
        user2Cards: null,
      }
    }
  }
});